import { PsicologoService } from 'src/app/shared/services/psicologo.service';
import { ChangeDetectorRef, Component, OnInit, ViewChild, inject } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { Subject, lastValueFrom } from "rxjs";
import { DataTableDirective } from "angular-datatables";
import { ADTSettings } from "angular-datatables/src/models/settings";

// Models
import { Diretoria } from "src/app/shared/models/diretoria/Diretoria";
import { Escola } from "src/app/shared/models/escola/Escola";
import { LogPlanoContingencia, PlanoContingencia } from 'src/app/shared/models/plano-contingencia/plano-contingencia';
import { AtribuicaoLoginSed, UserLoginSed } from "src/app/shared/models/sed/UserLogin";
import { DefaultResponse } from 'src/app/shared/models/DefaultResponse';
import { Polo } from "src/app/shared/models/polo/Polo";
import { PlanoStatus } from 'src/app/shared/enums/PlanoContingencia/PlanoStatus';
import { Perfil } from 'src/app/shared/enums/Perfis/Perfis';

// Services
import { AuthService } from "src/app/shared/auth/services/auth.service";
import { ConvivaErrorHandlingService } from "src/app/shared/services/convivaErrorHandlingService";
import { EscolaService } from "src/app/shared/services/escola.service";
import { PlanoContingenciaService } from "src/app/shared/services/plano-contingencia.service";
import { ArquivoService } from "src/app/shared/services/arquivo.service";

// UI Commons
import { angularCommonImports } from "src/app/shared/ui/angular-common";
import { convivaCommonImports } from "src/app/shared/ui/conviva-common";
import { libsCommonImports } from "src/app/shared/ui/libs-common";
import { Risco } from 'src/app/shared/models/plano-contingencia/risco';
import { ArquivoAzure } from 'src/app/shared/models/arquivo/ArquivoAzure';
import { PlanoContingenciaCadastroComponent } from '../cadastro/plano-contingencia-cadastro.component';
import { CardArquivoAnexadoComponent } from 'components/card-arquivo-anexado/card-arquivo-anexado.component';
import { VisualizarArquivoComponent } from 'components/visualizar-arquivo/visualizar-arquivo.component';

@Component({
  selector: "app-plano-contingencia-consulta",
  templateUrl: "./plano-contingencia-consulta.component.html",
  styleUrls: ["./plano-contingencia-consulta.component.scss"],
  standalone: true,
  imports: [angularCommonImports, convivaCommonImports, libsCommonImports, PlanoContingenciaCadastroComponent, CardArquivoAnexadoComponent, VisualizarArquivoComponent],
})
export class PlanoContingenciaConsultaComponent implements OnInit {
  // Injeções
  authService = inject(AuthService);
  spinnerService = inject(NgxSpinnerService);
  toastr = inject(ToastrService);
  escolaService = inject(EscolaService);
  psicologoService = inject(PsicologoService);
  planoService = inject(PlanoContingenciaService);
  private arquivoService = inject(ArquivoService);
  ConvivaErrors = inject(ConvivaErrorHandlingService);
  router = inject(Router);
  private route = inject(ActivatedRoute);
  private cdr = inject(ChangeDetectorRef);

  // Usuário logado
  public userLogado: UserLoginSed | null;
  public atribuicoesLogin: AtribuicaoLoginSed;

  // Grid DataTable
  public dtOptions: any = {};
  public dtTrigger: Subject<ADTSettings> = new Subject<ADTSettings>();
  @ViewChild(DataTableDirective, { static: false })
  public dtElement: DataTableDirective;
  public isDtInitialized: boolean = false;

  // Formulário
  public formConsulta!: FormGroup;
  public get form() {
    return this.formConsulta.controls;
  }
  public submitted: boolean = false;
  public showPesquisa: boolean = false;
  public PlanoStatus = PlanoStatus;
  public Perfil = Perfil;

  // Listas
  public polos: Polo[] = [];
  public diretorias: Diretoria[] = [];
  public escolas: Escola[] = [];
  public lstPlanos: PlanoContingencia[] = [];

  // Modal reprovação
  public showModalVisualizar = false;
  /** Modal dedicado "Histórico de atualizações" (abre a partir do modal Visualizar). */
  public showModalHistorico = false;
  public showCadastroModal = false;
  public planoSelecionado: PlanoContingencia | null = null;
  public riscosSelecionados: Risco[] = [];
  public showModalVisualizarArquivo = false;
  public arquivoVisualizando: ArquivoAzure | undefined;
  public justificativa: string | null = null;
  public qtdeCaracteres: number = 0;
  public riscoAberto: number | null = null;
  public showModalConfirmacao = false;
  public acaoModal: 'aprovar' | 'reprovar' | null = null;
  public codigoPlanoSelecionado: number | null = null;
  public ehEdit = false;
  public ehReadOnly = false;
  public tituloAcaoModal: string = '';
  public statusPlano: any = null;
  /** Cenário 2: true quando Editar plano aprovado (apenas inclusão de anexos e riscos). */
  public somenteAnexosERiscos = false;
  /** true quando o plano está aguardando validação (status 4/5) — formulário somente leitura. */
  public ehReadOnlyCadastro = false;
  public showModalEnviarValidacao = false;
  public codigoPlanoEnviarValidacao: number | null = null;
  public anoModalEnviar = '';
  public escolaModalEnviar = '';
  /** Detalhes exibidos no modal de aprovar/reprovar. */
  public anoModalConfirmacao = '';
  public escolaModalConfirmacao = '';
  public dataRegistroModalConfirmacao = '';
  /** Modal de exclusão */
  public showModalExcluir = false;
  public codigoPlanoExcluir: number | null = null;
  public anoModalExcluir = '';
  public escolaModalExcluir = '';

  /** Filtros por coluna (pesquisa dentro de cada coluna) */
  public filterAno = '';
  public filterNomeEscola = '';
  public filterNome = '';
  public filterDataRegistro = '';
  public filterVigencia = '';
  public filterStatus = '';

  /** Filtro vindo do pop-up (?validacao=supervisor|pec) — usa a mesma consulta da contagem. */
  private filtroValidacaoPendente: 'supervisor' | 'pec' | null = null;

  constructor() {
    this.userLogado = this.authService.getUser();
    if (this.userLogado != null && !this.userLogado.flPsicologo) {
      this.atribuicoesLogin = this.userLogado?.DadosUsuario[0];
    }
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      const v = params['validacao'];
      if (v === 'supervisor') {
        this.filtroValidacaoPendente = 'supervisor';
        this.filterStatus = 'aguardando validação supervisor';
      } else if (v === 'pec') {
        this.filtroValidacaoPendente = 'pec';
        this.filterStatus = 'aguardando validação pec';
      } else {
        this.filtroValidacaoPendente = null;
      }
    });
    this.inicializar();
  }

  private async inicializar(): Promise<void> {
    this.dtOptions = {
      deferRender: true,
      destroy: true,
      processing: true,
      paging: true,
      searching: false,
      dom: 'Bfrtip',
      language: {
        url: 'https://cdn.datatables.net/plug-ins/1.11.5/i18n/pt-BR.json'
      },
      lengthMenu: [
        [10, 25, 50, -1],
        ['10 linhas', '25 linhas', '50 linhas', 'Tudo']
      ],
      buttons: [
        'pageLength',
        {
          extend: 'print',
          text: 'Imprimir',
          className: 'btn-export-imprimir',
          stripHtml: false,
          exportOptions: { columns: ':visible' }
        },
        {
          extend: 'copy',
          text: 'Html',
          className: 'btn-export-html',
          exportOptions: { columns: ':visible' }
        },
        {
          extend: 'excel',
          text: 'Excel',
          className: 'btn-export-excel',
          exportOptions: { columns: ':visible' }
        },
        {
          extend: 'pdf',
          text: 'PDF',
          orientation: 'landscape',
          className: 'btn-export-pdf',
          exportOptions: { columns: ':visible' }
        }
      ]
    };

    // Formulário de filtros (Polo não exibido – preenchido em background quando houver)
    this.formConsulta = new FormGroup({
      codigoPolo: new FormControl(0),
      codigoDiretoria: new FormControl(null, [Validators.required]),
      codigoEscola: new FormControl(null)
    });

    await this.getPolosPerfilDiretor();

    this.dtTrigger.next(this.dtOptions);
  }

  //#region Filtros

  public async getPolosPerfilDiretor() {

    this.spinnerService.show();
    const response = await lastValueFrom(this.psicologoService.getPolos(this.userLogado?.DadosUsuario[0].CodigoDiretoria)).catch((err) => {
      return this.ConvivaErrors.handleResultError(err);
    });

    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }
    this.polos = response.data;
    if (this.polos?.length) {
      this.formConsulta.get('codigoPolo')?.setValue(this.polos[0].codigoPolo);
    }
    await this.getDiretorias();

    this.spinnerService.hide();
  }

  public async getDiretorias() {
    this.spinnerService.show();

    const response = await lastValueFrom(
      this.escolaService.getDiretoriaPorTipoDiretoria()
    ).catch((err) => this.ConvivaErrors.handleResultError(err));

    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }

    this.diretorias = response.data;

    if (this.userLogado?.codigoDiretoria) {
      this.formConsulta.get("codigoDiretoria")?.setValue(this.userLogado.codigoDiretoria);
      this.formConsulta.get("codigoDiretoria")?.disable();
      await this.getEscolas();
    }

    this.spinnerService.hide();
  }

  public async getEscolas() {
    const codigoDE = this.form?.codigoDiretoria.value;
    if (!codigoDE) return;

    this.spinnerService.show();
    const response = await lastValueFrom(
      this.escolaService.getEscolasPorCodigoDiretoria(codigoDE)
    ).catch((err) => this.ConvivaErrors.handleResultError(err));

    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }

    this.escolas = response.data;

    // Validação (Supervisor/PEC): mesma escopo da contagem do pop-up — toda a diretoria (escola=0).
    if (this.filtroValidacaoPendente) {
      this.formConsulta.get("codigoEscola")?.enable();
      this.formConsulta.get("codigoEscola")?.setValue(null);
    } else if (this.userLogado?.codigoEscola) {
      const existe = this.escolas.find(x => x.codigoEscola === this.userLogado!.codigoEscola);
      if (existe) {
        this.formConsulta.get("codigoEscola")?.setValue(this.userLogado.codigoEscola);
        this.formConsulta.get("codigoEscola")?.disable();
      }
    } else {
      this.formConsulta.get("codigoEscola")?.enable();
      this.formConsulta.get("codigoEscola")?.setValue(null);
    }

    this.spinnerService.hide();

    await this.PesquisarPlanos();
  }

  public async PesquisarPlanos() {
    this.spinnerService.show();
    this.submitted = true;

    if (this.formConsulta.invalid) {
      this.showPesquisa = false;
      this.spinnerService.hide();
      return;
    }

    this.showPesquisa = true;

    const parametros = {
      codigoPolo: this.form?.codigoPolo.value,
      codigoDiretoria: this.form?.codigoDiretoria.value,
      codigoEscola: this.form?.codigoEscola.value ?? 0
    };

    let response: DefaultResponse;

    if (this.filtroValidacaoPendente === 'supervisor') {
      // Mesma consulta da contagem (GetContagemPendenciasValidacao — Supervisor): DE + status 4, sem escola.
      response = await lastValueFrom(
        this.planoService.getPlanosPorDiretoriaEscolaEStatus(
          parametros.codigoDiretoria,
          0,
          PlanoStatus.AguardandoValidacaoSupervisor
        )
      ).catch((err) => this.ConvivaErrors.handleResultError(err));
    } else if (this.filtroValidacaoPendente === 'pec') {
      // Mesma consulta da contagem (GetContagemPendenciasValidacao — PEC): DE + status 5, sem escola.
      response = await lastValueFrom(
        this.planoService.getPlanosPorDiretoriaEscolaEStatus(
          parametros.codigoDiretoria,
          0,
          PlanoStatus.AguardandoValidacaoPecConviva
        )
      ).catch((err) => this.ConvivaErrors.handleResultError(err));
    } else {
      response = await lastValueFrom(
        this.planoService.getPlanos(parametros.codigoPolo, parametros.codigoDiretoria, parametros.codigoEscola)
      ).catch((err) => this.ConvivaErrors.handleResultError(err));
    }

    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }

    this.lstPlanos = response.data ?? [];
    this.spinnerService.hide();

    if (this.lstPlanos.length == 0) {
      this.toastr.warning("Nenhum plano encontrado.");
    }

    this.cdr.detectChanges();
    setTimeout(async () => {
      this.cdr.detectChanges();
      if (this.isDtInitialized && this.dtElement) {
        const dtInstance = await this.dtElement.dtInstance;
        try {
          dtInstance.destroy();
        } catch (error) {
          console.error(error);
        }
        setTimeout(() => {
          this.dtTrigger.next(this.dtOptions);
        }, 100);
      } else {
        this.isDtInitialized = true;
        this.dtTrigger.next(this.dtOptions);
      }
    }, 50);
  }


  public async abrirModalVisualizar(item: number) {
    this.spinnerService.show();

    const response = await lastValueFrom(
      this.planoService.getPlanoById(item)
    ).catch((err) => this.ConvivaErrors.handleResultError(err));

    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }

    this.planoSelecionado = response.data;
    this.riscosSelecionados = response.data.riscos ?? [];
    this.ehEdit = false;
    this.ehReadOnly = true;
    this.somenteAnexosERiscos = false;
    this.tituloAcaoModal = 'Visualizar Plano de Contingência';
    this.statusPlano = response.data.status;
    this.showCadastroModal = true;
    this.spinnerService.hide();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }


  /** Abre o modal "Histórico de atualizações" (modelo da imagem: lista Atualizado em + responsável, botão Fechar). */
  public abrirModalHistorico(): void {
    this.showModalHistorico = true;
  }

  /** Fecha o modal Histórico de atualizações. */
  public fecharModalHistorico(): void {
    this.showModalHistorico = false;
  } 

  /** Indica se o responsável no log parece ser um ID (apenas dígitos) para estilização. */
  public ehIdResponsavel(nome: string | undefined): boolean {
    if (!nome || typeof nome !== 'string') return false;
    return /^\d+$/.test(nome.trim());
  }

  /** Texto amigável para exibição do tipo de operação no histórico (TP_OPERACAO: I=Cadastro, U=Edição, A=Aprovação/Envio, R=Reprovação, D=Exclusão). */
  public getTextoOperacaoLog(log: LogPlanoContingencia): string {
    const op = (log.tipoOperacao ?? '').toUpperCase();
    const ap = String(log.tipoAprovacao ?? '');
    if (op === 'I') return 'Cadastro';
    if (op === 'U') return 'Edição';
    if (op === 'D') return 'Exclusão';
    if (op === 'R') return 'Reprovação / Devolvido para ajustes';
    if (op === 'A') return (ap === '2' || Number(log.tipoAprovacao) === 2) ? 'Enviado para validação' : 'Aprovação';
    return log.tipoOperacao || 'Atualização';
  }

  // fechar modal
  public fecharModalVisualizar() {
    this.showModalVisualizar = false;
    this.planoSelecionado = null;
    this.riscosSelecionados = [];
    this.fecharModalVisualizarArquivo();
  }

  public FecharCadastroModal() {
    this.showCadastroModal = false;
    this.planoSelecionado = null;
    this.statusPlano = undefined;
    this.ehEdit = false;
    this.ehReadOnly = false;
    this.somenteAnexosERiscos = false;
    this.ehReadOnlyCadastro = false;
  }

  public abrirModalCadastro(plano: PlanoContingencia) {
    this.planoSelecionado = plano;
    this.ehEdit = true;
    this.ehReadOnly = false;
    this.somenteAnexosERiscos = this.ehEdicaoApenasAnexosERiscos(plano);
    this.ehReadOnlyCadastro = this.itemEstaAguardandoValidacao(plano);
    this.showCadastroModal = true;
    this.tituloAcaoModal = this.ehReadOnlyCadastro
      ? 'Visualizar Plano de Contingência'
      : this.somenteAnexosERiscos
        ? 'Editar Plano (apenas anexos e riscos)'
        : 'Editar Plano de Contingência';
    this.statusPlano = plano.status;
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  public abrirRisco(index: number): void {
    this.riscoAberto = this.riscoAberto === index ? null : index;
  }

  /** Retorna os arquivos do risco pelo índice (modal visualizar – somente leitura). */
  public getArquivosRiscoVisualizar(riscoIndex: number): ArquivoAzure[] {
    const risco = this.riscosSelecionados?.[riscoIndex];
    return risco?.arquivos ?? [];
  }

  public visualizarArquivo(index: number, riscoIndex: number): void {
    const arquivos = this.getArquivosRiscoVisualizar(riscoIndex);
    if (index >= 0 && index < arquivos.length) {
      this.arquivoVisualizando = arquivos[index];
      this.showModalVisualizarArquivo = true;
    }
  }

  public fecharModalVisualizarArquivo(): void {
    this.showModalVisualizarArquivo = false;
    this.arquivoVisualizando = undefined;
  }

  public async downloadArquivoVisualizar(index: number, riscoIndex: number): Promise<void> {
    const arquivos = this.getArquivosRiscoVisualizar(riscoIndex);
    if (index < 0 || index >= arquivos.length) return;
    const arquivo = arquivos[index];
    this.spinnerService.show();
    try {
      const response = await lastValueFrom(this.arquivoService.getArquivoPorNome(arquivo.nome));
      const url = window.URL.createObjectURL(response);
      const link = document.createElement('a');
      link.href = url;
      link.download = arquivo.nome;
      link.click();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      this.ConvivaErrors.handleResultError(err);
    } finally {
      this.spinnerService.hide();
    }
  }

  public abrirModalConfirmacao(plano: PlanoContingencia, acao: 'aprovar' | 'reprovar') {
    this.codigoPlanoSelecionado = plano.cdPlano;
    this.acaoModal = acao;
    this.anoModalConfirmacao = plano.vigencia ?? '';
    this.escolaModalConfirmacao = plano.nmEscola ?? '';
    const data = plano.dataRevisao ?? plano.dataInclusao;
    this.dataRegistroModalConfirmacao = data
      ? (typeof data === 'string' ? new Date(data) : data).toLocaleDateString('pt-BR')
      : '';
    this.showModalConfirmacao = true;
  }

  public fecharModalConfirmacao() {
    this.showModalConfirmacao = false;
    this.acaoModal = null;
    this.codigoPlanoSelecionado = null;
    this.justificativa = null;
    this.anoModalConfirmacao = '';
    this.escolaModalConfirmacao = '';
    this.dataRegistroModalConfirmacao = '';
  }

  /** Lista filtrada por coluna (pesquisa dentro de cada coluna). */
  public get filteredPlanos(): PlanoContingencia[] {
    const list = this.lstPlanos || [];
    const a = (this.filterAno || '').trim().toLowerCase();
    const e = (this.filterNomeEscola || '').trim().toLowerCase();
    const n = (this.filterNome || '').trim().toLowerCase();
    const d = (this.filterDataRegistro || '').trim().toLowerCase();
    const v = (this.filterVigencia || '').trim().toLowerCase();
    const s = (this.filterStatus || '').trim().toLowerCase();
    if (!a && !e && !n && !d && !v && !s) {
      return list;
    }
    return list.filter((item) => {
      const dataStr = (item.dataRevisao || item.dataInclusao)
        ? this.formatDateForFilter(item.dataRevisao || item.dataInclusao)
        : '';
      const statusStr = this.getTextoStatus(item.status).toLowerCase();
      return (
        (!a || (item.vigencia || '').toLowerCase().includes(a)) &&
        (!e || (item.nmEscola || '').toLowerCase().includes(e)) &&
        (!n || (item.nomeResponsavel || '').toLowerCase().includes(n)) &&
        (!d || dataStr.includes(d)) &&
        (!v || (item.vigencia || '').toLowerCase().includes(v)) &&
        (!s || statusStr.includes(s))
      );
    });
  }

  private formatDateForFilter(d: Date | string | undefined): string {
    if (!d) return '';
    const date = typeof d === 'string' ? new Date(d) : d;
    if (isNaN(date.getTime())) return '';
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`.toLowerCase();
  }

  /** Texto do status exibido na listagem (alinhado ao PMCE/FIGMA). Reprovado (2) exibe como Devolvido para ajustes. Aceita número ou string da API. */
  public getTextoStatus(status: PlanoStatus | string | number | undefined): string {
    const s = status !== undefined && status !== null ? Number(status) : NaN;
    switch (s) {
      case PlanoStatus.Pendente:
        return 'Pendente';
      case PlanoStatus.Aprovado:
        return 'Aprovado';
      case PlanoStatus.Reprovado:
      case PlanoStatus.DevolvidoAjustes:
        return 'Devolvido para ajustes';
      case PlanoStatus.Novo:
        return 'Novo';
      case PlanoStatus.AguardandoValidacaoSupervisor:
        return 'Aguardando validação Supervisor de Ensino';
      case PlanoStatus.AguardandoValidacaoPecConviva:
        return 'Aguardando validação PEC CONVIVA';
      default:
        return 'Pendente';
    }
  }

  /** Classe CSS da bolinha de status (Figma). Aceita número ou string vinda da API. */
  public getClasseBolinhaStatus(status: PlanoStatus | string | number | undefined): string {
    const s = status !== undefined && status !== null ? Number(status) : NaN;
    switch (s) {
      case PlanoStatus.Pendente: return 'status-pendente';
      case PlanoStatus.Aprovado: return 'status-aprovado';
      case PlanoStatus.Reprovado:
      case PlanoStatus.DevolvidoAjustes: return 'status-devolvido';
      case PlanoStatus.Novo: return 'status-novo';
      case PlanoStatus.AguardandoValidacaoSupervisor:
      case PlanoStatus.AguardandoValidacaoPecConviva: return 'status-aguardando';
      default: return 'status-pendente';
    }
  }

  /** Código do perfil do usuário logado (sempre número; suporta CodigoPerfil/codigoPerfil da API). */
  private get codigoPerfilLogado(): number {
    const d = this.userLogado?.DadosUsuario?.[0] as any;
    const v = d?.CodigoPerfil ?? d?.codigoPerfil ?? this.userLogado?.codigoPerfil;
    return Number(v);
  }

  private ehPerfilPEC(): boolean {
    return this.codigoPerfilLogado === Perfil.PEC;
  }

  private ehPerfilSupervisor(): boolean {
    return this.codigoPerfilLogado === Perfil.SupervisorEducacional;
  }

  private ehPerfilGestorConviva(): boolean {
    return this.codigoPerfilLogado === Perfil.GestorConviva;
  }

  /** PEC: só Visualizar/download. Supervisor e Gestor: Visualizar + Aprovar/Reprovar (quando status permitir). Não veem Editar, Excluir, Enviar, Cadastrar. */
  private ehPerfilSoVisualizacaoOuValidacao(): boolean {
    return this.ehPerfilPEC() || this.ehPerfilSupervisor() || this.ehPerfilGestorConviva();
  }

  /** Exibe botão Enviar para Validação quando status é Novo (3) ou Devolvido para ajustes (2 ou 6). Cenário 2. */
  public podeEnviarParaValidacao(item: PlanoContingencia): boolean {
    if (this.ehPerfilSoVisualizacaoOuValidacao()) return false;
    const status = this.getStatusNumero(item);
    return status === PlanoStatus.Reprovado || status === PlanoStatus.Novo || status === PlanoStatus.DevolvidoAjustes;
  }

  /** Número do status do plano. Lê status em várias formas (API pode enviar status, Status, cdStatus, etc.). */
  public getStatusNumero(item: PlanoContingencia): number {
    const anyItem = item as any;
    const raw = anyItem.status ?? anyItem.Status ?? anyItem.cdStatus ?? anyItem.CD_STATUS ?? anyItem.statusPlano;
    if (raw === undefined || raw === null) return 0;
    if (typeof raw === 'number') return raw;
    const n = Number(raw);
    return isNaN(n) ? 0 : n;
  }

  /** Oculta apenas Excluir quando status é Aprovado (1). Cenário 2: Excluir somente se não aprovado. */
  public deveOcultarExcluirPorStatus(item: PlanoContingencia): boolean {
    return this.getStatusNumero(item) === PlanoStatus.Aprovado;
  }

  /** Indica se o plano está com status Devolvido para ajustes (2 Reprovado ou 6 DevolvidoAjustes). Cenário 8: exibir justificativa. */
  public ehStatusDevolvidoParaAjustes(item: PlanoContingencia | null | undefined): boolean {
    if (!item) return false;
    const s = this.getStatusNumero(item);
    return s === PlanoStatus.Reprovado || s === PlanoStatus.DevolvidoAjustes;
  }

  /** Indica se o plano está com status Aprovado (1). */
  public itemEstaAprovado(item: PlanoContingencia): boolean {
    return this.getStatusNumero(item) === PlanoStatus.Aprovado;
  }

  /** Indica se o plano está aguardando validação: status 4 (Supervisor) ou 5 (PEC CONVIVA). Formulário somente leitura; exclusão bloqueada. */
  public itemEstaAguardandoValidacao(item: PlanoContingencia): boolean {
    const n = this.getStatusNumero(item);
    return n === PlanoStatus.AguardandoValidacaoSupervisor || n === PlanoStatus.AguardandoValidacaoPecConviva;
  }

  /** Exibe botão Editar. Aprovado = apenas anexos/riscos; Aguardando validação (4/5) = abre somente leitura; demais = edição completa. */
  public mostrarEditar(item: PlanoContingencia): boolean {
    if (this.ehPerfilSoVisualizacaoOuValidacao()) return false;
    return true;
  }

  /** Exibe botão Excluir.
   *  Regra atual:
   *  - Diretor / perfis de escola: podem excluir enquanto o plano NÃO estiver Aprovado (1) nem aguardando validação (4/5).
   *  - PEC, Supervisor de Ensino e Gestor CONVIVA: nunca veem o botão Excluir.
   */
  public podeExcluir(item: PlanoContingencia): boolean {
    // PEC (só visualização), Supervisor e Gestor CONVIVA não podem excluir na tela de consulta
    if (this.ehPerfilPEC() || this.ehPerfilSupervisor() || this.ehPerfilGestorConviva()) {
      return false;
    }

    if (this.itemEstaAguardandoValidacao(item)) return false;

    const status = this.getStatusNumero(item);
    return status !== PlanoStatus.Aprovado;
  }

  /** TrackBy para a lista de planos na tabela (melhora binding após redraw do DataTables). */
  public trackByCdPlano(_index: number, item: PlanoContingencia): number {
    return item?.cdPlano ?? _index;
  }

  /** Indica se, ao editar, deve permitir apenas inclusão de anexos e riscos (status Aprovado). Cenário 2. */
  public ehEdicaoApenasAnexosERiscos(item: PlanoContingencia): boolean {
    return this.getStatusNumero(item) === PlanoStatus.Aprovado;
  }

  public abrirModalExcluir(plano: PlanoContingencia) {
    this.codigoPlanoExcluir = plano.cdPlano;
    this.anoModalExcluir = plano.vigencia ?? '';
    this.escolaModalExcluir = plano.nmEscola ?? '';
    this.showModalExcluir = true;
  }

  public fecharModalExcluir() {
    this.showModalExcluir = false;
    this.codigoPlanoExcluir = null;
    this.anoModalExcluir = '';
    this.escolaModalExcluir = '';
  }

  public async confirmarExcluir() {
    if (!this.codigoPlanoExcluir) return;
    this.spinnerService.show();
    try {
      const codigoPerfil = this.userLogado?.DadosUsuario?.[0]?.CodigoPerfil ?? this.userLogado?.codigoPerfil ?? 0;
      const nomePerfil = this.userLogado?.DadosUsuario?.[0]?.NomePerfil ?? this.userLogado?.nomePerfil ?? '';
      const response = await lastValueFrom(this.planoService.setEliminarPlano({
        codigoPlano: this.codigoPlanoExcluir,
        codigoPerfil,
        nomePerfil
      }));
      if (!response.isSucess) {
        this.toastr.error(response.message);
        return;
      }
      this.toastr.success(response.message ?? 'Plano excluído com sucesso.');
      await this.PesquisarPlanos();
      this.fecharModalExcluir();
    } catch (err) {
      this.toastr.error('Erro ao excluir o plano.');
    } finally {
      this.spinnerService.hide();
    }
  }

  /** Exibe Aprovar/Reprovar: Supervisor e Gestor CONVIVA quando status = 4 (fluxo) ou 5 (legado). PEC não valida. */
  public podeAprovarOuReprovar(item: PlanoContingencia): boolean {
    const codigoPerfil = this.codigoPerfilLogado;
    const status = this.getStatusNumero(item);
    const statusPermitido =
      status === PlanoStatus.AguardandoValidacaoSupervisor ||
      status === PlanoStatus.AguardandoValidacaoPecConviva;
    if (codigoPerfil === Perfil.SupervisorEducacional || codigoPerfil === Perfil.GestorConviva)
      return statusPermitido;
    return false;
  }

  /** Exibe botão Cadastrar plano. PEC, Supervisor e Gestor não cadastram (só visualizam ou aprovam/reprovam). */
  public mostrarBotaoCadastrar(): boolean {
    return !this.ehPerfilSoVisualizacaoOuValidacao();
  }

  public abrirModalEnviarValidacao(codigoPlano: number, ano: string, escola: string) {
    this.codigoPlanoEnviarValidacao = codigoPlano;
    this.anoModalEnviar = ano;
    this.escolaModalEnviar = escola;
    this.showModalEnviarValidacao = true;
  }

  public fecharModalEnviarValidacao() {
    this.showModalEnviarValidacao = false;
    this.codigoPlanoEnviarValidacao = null;
    this.anoModalEnviar = '';
    this.escolaModalEnviar = '';
  }

  public navigateToCadastrarPlano() {
    this.router.navigate(['/plano-contingencia/cadastro'], { queryParams: { openModal: 'true' } });
  }

  public async confirmarEnviarValidacao() {
    if (!this.codigoPlanoEnviarValidacao) return;
    const parametros = {
      codigoPlano: this.codigoPlanoEnviarValidacao,
      codigoUsuario: this.userLogado?.codigoUsuario ?? 0,
      codigoPerfil: this.atribuicoesLogin?.CodigoPerfil ?? 0,
      nomePerfil: this.atribuicoesLogin?.NomePerfil ?? ''
    };
    this.spinnerService.show();
    const result = await lastValueFrom(this.planoService.setEnviarParaValidacao(parametros))
      .catch((err) => this.ConvivaErrors.handleResultError(err));
    if (!result.isSucess) {
      this.toastr.error(result.message);
      this.spinnerService.hide();
      return;
    }
    this.toastr.success('Plano de Contingência enviado para validação com sucesso!');
    this.spinnerService.hide();
    this.fecharModalEnviarValidacao();
    await this.PesquisarPlanos();
  }

  public async confirmarAcao() {
    if (!this.codigoPlanoSelecionado || !this.acaoModal) return;

    if (this.acaoModal === 'reprovar') {
      if (!this.justificativa || this.justificativa.trim().length < 150) {
        this.toastr.warning("A justificativa deve ter no mínimo 150 caracteres.");
        return;
      }
      if (this.justificativa.length > 1000) {
        this.toastr.warning("A justificativa deve ter no máximo 1000 caracteres.");
        return;
      }
    }

    this.spinnerService.show();

    try {
      const codigoPerfil = this.userLogado?.DadosUsuario?.[0]?.CodigoPerfil ?? this.userLogado?.codigoPerfil ?? 0;
      const nomePerfil = this.userLogado?.DadosUsuario?.[0]?.NomePerfil ?? this.userLogado?.nomePerfil ?? '';
      const parametros: any = {
        codigoPlano: this.codigoPlanoSelecionado,
        codigoPerfil,
        nomePerfil
      };

      if (this.acaoModal === 'reprovar') {
        parametros.justificativa = this.justificativa?.trim();
      }

      let response: DefaultResponse;
      if (this.acaoModal === 'aprovar') {
        response = await lastValueFrom(this.planoService.setPlanoAprovado(parametros));
      } else {
        response = await lastValueFrom(this.planoService.setPlanoReprovado(parametros));
      }

      if (!response.isSucess) {
        this.toastr.error(response.message);
        return;
      }

      this.toastr.success(response.message ?? `Plano ${this.codigoPlanoSelecionado} ${this.acaoModal} com sucesso!`);
      await this.PesquisarPlanos();
    } catch (err) {
      this.toastr.error("Erro ao executar a operação.");
    } finally {
      this.spinnerService.hide();
      this.fecharModalConfirmacao();
    }
  }

  public gerarPDFPlano(): void {
    if (!this.planoSelecionado) {
      this.toastr.error('Nenhum plano disponível para download');
      return;
    }

    this.spinnerService.show();

    try {
      const jsPDFConstructor = (window as any).jspdf?.jsPDF || (window as any).jsPDF;

      if (!jsPDFConstructor) {
        throw new Error('jsPDF não está carregado. Verifique o index.html');
      }

      const doc = new jsPDFConstructor();

      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const margin = 15;
      const maxWidth = pageWidth - (margin * 2);
      let yPosition = margin;

      const checkAndAddPage = (requiredSpace: number = 20): boolean => {
        if (yPosition + requiredSpace > pageHeight - margin) {
          doc.addPage();
          yPosition = margin;
          return true;
        }
        return false;
      };

      // ========== CABEÇALHO ==========
      doc.setFillColor(26, 122, 154);
      doc.rect(0, 0, pageWidth, 35, 'F');

      doc.setTextColor(255, 255, 255);
      doc.setFontSize(18);
      doc.setFont('helvetica', 'bold');
      doc.text('Plano de Contingencia Escolar', pageWidth / 2, 15, { align: 'center' });

      doc.setFontSize(10);
      doc.setFont('helvetica', 'normal');
      const dataGeracao = new Date().toLocaleDateString('pt-BR', {
        day: '2-digit', month: '2-digit', year: 'numeric',
        hour: '2-digit', minute: '2-digit'
      });
      doc.text(`Gerado em: ${dataGeracao}`, pageWidth / 2, 25, { align: 'center' });

      yPosition = 45;
      doc.setTextColor(0, 0, 0);

      // ========== INFORMAÇÕES DO PLANO ==========
      doc.setFillColor(240, 240, 240);
      doc.rect(margin, yPosition, maxWidth, 8, 'F');
      doc.setFontSize(12);
      doc.setFont('helvetica', 'bold');
      doc.text('INFORMACOES DO PLANO', margin + 2, yPosition + 6);
      yPosition += 12;

      // Status com círculo colorido
      doc.setFontSize(10);
      doc.setFont('helvetica', 'bold');
      doc.text('Status:', margin, yPosition);

      const statusTexto = this.getStatusTextoPDF(this.planoSelecionado.status ?? 0);
      const statusCor = this.getStatusColorPDF(this.planoSelecionado.status ?? 0);

      doc.setFillColor(statusCor[0], statusCor[1], statusCor[2]);
      doc.circle(margin + 20, yPosition - 2, 2, 'F');

      doc.setFont('helvetica', 'normal');
      doc.text(statusTexto, margin + 25, yPosition);
      yPosition += 10;

      const infoData = [
        ['Vigencia', this.planoSelecionado.vigencia?.toString() || 'N/A'],
        ['URE (Diretoria)', this.planoSelecionado.nmDiretoria || 'N/A'],
        ['Escola', this.planoSelecionado.nmEscola || 'N/A'],
        ['Responsavel (Diretor)', this.planoSelecionado.nomeResponsavel || 'N/A'],
        ['Codigo do Plano', this.planoSelecionado.cdPlano?.toString() || 'N/A'],
      ];

      doc.autoTable({
        startY: yPosition,
        head: [],
        body: infoData,
        theme: 'grid',
        styles: { fontSize: 9, cellPadding: 3 },
        columnStyles: {
          0: { fontStyle: 'bold', cellWidth: 50, fillColor: [245, 245, 245] },
          1: { cellWidth: maxWidth - 50 }
        },
        margin: { left: margin, right: margin }
      });

      yPosition = doc.lastAutoTable.finalY + 12;

      // ========== JUSTIFICATIVA DE REPROVAÇÃO (se aplicável) ==========
      const anyPlano = this.planoSelecionado as any;
      const justificativaReprovacao: string =
        anyPlano?.justificativa ?? anyPlano?.Justificativa ?? anyPlano?.dsJustificativa ?? anyPlano?.DS_JUSTIFICATIVA ?? '';

      if ((this.planoSelecionado.status === 2 || this.planoSelecionado.status === 6) && justificativaReprovacao) {
        checkAndAddPage(35);

        doc.setFillColor(255, 220, 220);
        doc.rect(margin, yPosition, maxWidth, 8, 'F');
        doc.setFontSize(11);
        doc.setFont('helvetica', 'bold');
        doc.setTextColor(203, 37, 37);
        doc.text('MOTIVO DA REPROVACAO / DEVOLUCAO', margin + 2, yPosition + 6);
        yPosition += 12;

        doc.setTextColor(0, 0, 0);
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(9);
        const justLines = doc.splitTextToSize(justificativaReprovacao, maxWidth - 4);
        justLines.forEach((line: string) => {
          checkAndAddPage();
          doc.text(line, margin + 2, yPosition);
          yPosition += 5;
        });
        yPosition += 10;
      }

      // ========== COMITÊ ==========
      checkAndAddPage(35);
      doc.setFillColor(240, 240, 240);
      doc.rect(margin, yPosition, maxWidth, 8, 'F');
      doc.setFontSize(11);
      doc.setFont('helvetica', 'bold');
      doc.setTextColor(0, 0, 0);
      doc.text('COMITE', margin + 2, yPosition + 6);
      yPosition += 12;

      doc.setFont('helvetica', 'normal');
      doc.setFontSize(9);
      const comiteLines = doc.splitTextToSize(this.planoSelecionado.comite || 'Nao informado', maxWidth - 4);
      comiteLines.forEach((line: string) => {
        checkAndAddPage();
        doc.text(line, margin + 2, yPosition);
        yPosition += 5;
      });
      yPosition += 10;

      // ========== RISCOS ==========
      if (this.riscosSelecionados && this.riscosSelecionados.length > 0) {
        checkAndAddPage(45);

        doc.setFillColor(26, 122, 154);
        doc.rect(margin, yPosition, maxWidth, 8, 'F');
        doc.setFontSize(12);
        doc.setFont('helvetica', 'bold');
        doc.setTextColor(255, 255, 255);
        doc.text(`RISCOS (${this.riscosSelecionados.length} risco(s) cadastrado(s))`, margin + 2, yPosition + 6);
        yPosition += 15;
        doc.setTextColor(0, 0, 0);

        this.riscosSelecionados.forEach((risco: Risco, index: number) => {
          checkAndAddPage(60);

          doc.setFillColor(230, 230, 230);
          doc.rect(margin, yPosition, maxWidth, 7, 'F');
          doc.setFontSize(10);
          doc.setFont('helvetica', 'bold');
          doc.text(`Risco ${index + 1}`, margin + 2, yPosition + 5);
          yPosition += 10;

          // --- SEÇÃO: RISCO ---
          doc.setFillColor(245, 245, 245);
          doc.rect(margin, yPosition, maxWidth, 6, 'F');
          doc.setFontSize(9);
          doc.setFont('helvetica', 'bold');
          doc.text('Risco', margin + 2, yPosition + 4);
          yPosition += 8;

          const riscoData: string[][] = [
            ['Perigo', Array.isArray(risco.perigo) ? risco.perigo.join(', ') : (risco.perigo || 'N/A')],
            ['Vulnerabilidade', Array.isArray(risco.vulnerabilidade) ? risco.vulnerabilidade.join(', ') : (risco.vulnerabilidade || 'N/A')],
            ['Justificativa de Vulnerabilidade', risco.justificativaVulnerabilidade || 'N/A'],
            ['Dano', Array.isArray(risco.dano) ? risco.dano.join(', ') : (risco.dano || 'N/A')],
            ['Justificativa de Dano', risco.justificativaDano || 'N/A'],
            ['Grau de Risco', risco.grauRisco || 'N/A'],
            ['Justificativa de Grau de Risco', risco.justificativaGrauRisco || 'N/A'],
          ];

          doc.autoTable({
            startY: yPosition,
            head: [],
            body: riscoData,
            theme: 'striped',
            styles: { fontSize: 8, cellPadding: 2.5 },
            columnStyles: {
              0: { fontStyle: 'bold', cellWidth: 55, fillColor: [250, 250, 250] },
              1: { cellWidth: maxWidth - 55 }
            },
            margin: { left: margin, right: margin }
          });
          yPosition = doc.lastAutoTable.finalY + 8;

          // --- SEÇÃO: AÇÕES ANTES DO FATO ---
          checkAndAddPage(30);
          doc.setFillColor(245, 245, 245);
          doc.rect(margin, yPosition, maxWidth, 6, 'F');
          doc.setFontSize(9);
          doc.setFont('helvetica', 'bold');
          doc.text('Acoes antes do fato', margin + 2, yPosition + 4);
          yPosition += 8;

          doc.autoTable({
            startY: yPosition,
            head: [],
            body: [
              ['Prevencao', risco.prevencao || 'N/A'],
              ['Mitigacao', risco.mitigacao || 'N/A'],
              ['Preparacao', risco.preparacao || 'N/A'],
            ],
            theme: 'striped',
            styles: { fontSize: 8, cellPadding: 2.5 },
            columnStyles: {
              0: { fontStyle: 'bold', cellWidth: 55, fillColor: [250, 250, 250] },
              1: { cellWidth: maxWidth - 55 }
            },
            margin: { left: margin, right: margin }
          });
          yPosition = doc.lastAutoTable.finalY + 8;

          // --- SEÇÃO: AÇÕES DURANTE O FATO ---
          checkAndAddPage(30);
          doc.setFillColor(245, 245, 245);
          doc.rect(margin, yPosition, maxWidth, 6, 'F');
          doc.setFontSize(9);
          doc.setFont('helvetica', 'bold');
          doc.text('Acoes durante o fato', margin + 2, yPosition + 4);
          yPosition += 8;

          doc.autoTable({
            startY: yPosition,
            head: [],
            body: [
              ['Evacuacao do Predio', risco.evacuacaoPredio || 'N/A'],
              ['Acionamento dos Orgaos', risco.acionamentoOrgaos || 'N/A'],
              ['Isolamento das Areas', risco.isolamentoAreas || 'N/A'],
              ['Comunicacao com URE', risco.comunicacaoURE || 'N/A'],
            ],
            theme: 'striped',
            styles: { fontSize: 8, cellPadding: 2.5 },
            columnStyles: {
              0: { fontStyle: 'bold', cellWidth: 55, fillColor: [250, 250, 250] },
              1: { cellWidth: maxWidth - 55 }
            },
            margin: { left: margin, right: margin }
          });
          yPosition = doc.lastAutoTable.finalY + 8;

          // --- SEÇÃO: AÇÕES DEPOIS DO FATO ---
          checkAndAddPage(30);
          doc.setFillColor(245, 245, 245);
          doc.rect(margin, yPosition, maxWidth, 6, 'F');
          doc.setFontSize(9);
          doc.setFont('helvetica', 'bold');
          doc.text('Avaliacao do Fato Ocorrido', margin + 2, yPosition + 4);
          yPosition += 8;

          doc.autoTable({
            startY: yPosition,
            head: [],
            body: [
              ['Avaliacao dos Danos', risco.avaliacaoDanos || 'N/A'],
              ['Limpeza e Reorganizacao', risco.limpezaReorganizacao || 'N/A'],
              ['Apoio Psicossocial', risco.apoioPsicossocial || 'N/A'],
              ['Revisao do Plano', risco.revisaoPlano || 'N/A'],
            ],
            theme: 'striped',
            styles: { fontSize: 8, cellPadding: 2.5 },
            columnStyles: {
              0: { fontStyle: 'bold', cellWidth: 55, fillColor: [250, 250, 250] },
              1: { cellWidth: maxWidth - 55 }
            },
            margin: { left: margin, right: margin }
          });
          yPosition = doc.lastAutoTable.finalY + 8;

          // --- SEÇÃO: ENCAMINHAMENTOS ---
          checkAndAddPage(25);
          doc.setFillColor(245, 245, 245);
          doc.rect(margin, yPosition, maxWidth, 6, 'F');
          doc.setFontSize(9);
          doc.setFont('helvetica', 'bold');
          doc.text('Encaminhamentos', margin + 2, yPosition + 4);
          yPosition += 8;

          doc.autoTable({
            startY: yPosition,
            head: [],
            body: [['Encaminhamentos', risco.encaminhamentos || 'N/A']],
            theme: 'striped',
            styles: { fontSize: 8, cellPadding: 2.5 },
            columnStyles: {
              0: { fontStyle: 'bold', cellWidth: 55, fillColor: [250, 250, 250] },
              1: { cellWidth: maxWidth - 55 }
            },
            margin: { left: margin, right: margin }
          });
          yPosition = doc.lastAutoTable.finalY + 8;

          // --- SEÇÃO: SISTEMA DE ALERTA / COMUNICAÇÃO ---
          checkAndAddPage(30);
          doc.setFillColor(245, 245, 245);
          doc.rect(margin, yPosition, maxWidth, 6, 'F');
          doc.setFontSize(9);
          doc.setFont('helvetica', 'bold');
          doc.text('Sistema de alerta / comunicacao', margin + 2, yPosition + 4);
          yPosition += 8;

          doc.autoTable({
            startY: yPosition,
            head: [],
            body: [
              ['Comunicacao Interna', risco.comunicacaoInterna || 'N/A'],
              ['Comunicacao Externa', risco.comunicacaoExterna || 'N/A'],
              ['Meios Sonoros/Visuais/Digitais', risco.meiosSonoros || 'N/A'],
            ],
            theme: 'striped',
            styles: { fontSize: 8, cellPadding: 2.5 },
            columnStyles: {
              0: { fontStyle: 'bold', cellWidth: 55, fillColor: [250, 250, 250] },
              1: { cellWidth: maxWidth - 55 }
            },
            margin: { left: margin, right: margin }
          });
          yPosition = doc.lastAutoTable.finalY + 8;

          // --- ROTA DE FUGA (anexos) ---
          checkAndAddPage(20);
          doc.setFillColor(245, 245, 245);
          doc.rect(margin, yPosition, maxWidth, 6, 'F');
          doc.setFontSize(9);
          doc.setFont('helvetica', 'bold');
          doc.text('Rota de fuga (anexos)', margin + 2, yPosition + 4);
          yPosition += 8;

          const documentosTexto = risco.arquivos && risco.arquivos.length > 0
            ? `${risco.arquivos.length} documento(s) anexado(s)`
            : 'Nenhum documento anexado';

          doc.autoTable({
            startY: yPosition,
            head: [],
            body: [['Documentos', documentosTexto]],
            theme: 'striped',
            styles: { fontSize: 8, cellPadding: 2.5 },
            columnStyles: {
              0: { fontStyle: 'bold', cellWidth: 55, fillColor: [250, 250, 250] },
              1: { cellWidth: maxWidth - 55 }
            },
            margin: { left: margin, right: margin }
          });
          yPosition = doc.lastAutoTable.finalY + 12;
        });

      } else {
        checkAndAddPage(20);
        doc.setFontSize(10);
        doc.setFont('helvetica', 'italic');
        doc.setTextColor(128, 128, 128);
        doc.text('Nenhum risco cadastrado no plano.', margin, yPosition);
        yPosition += 15;
        doc.setTextColor(0, 0, 0);
      }

      // ========== DECLARAÇÃO DE CIÊNCIA ==========
      const anyPlanoFull = this.planoSelecionado as any;
      if (anyPlanoFull.cienciaResponsaveis) {
        checkAndAddPage(35);

        doc.setFillColor(240, 255, 240);
        doc.rect(margin, yPosition, maxWidth, 8, 'F');
        doc.setFontSize(11);
        doc.setFont('helvetica', 'bold');
        doc.setTextColor(31, 206, 124);
        doc.text('DECLARACAO DE CIENCIA DOS RESPONSAVEIS', margin + 2, yPosition + 6);
        yPosition += 12;

        doc.setTextColor(0, 0, 0);
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(8);

        const declaracao = 'Declaro, na qualidade de Diretor(a) da Unidade Escolar, que todas as pessoas citadas como responsaveis neste plano foram devidamente informadas e estao cientes de suas atribuicoes, compromissos e responsabilidades no ambito das acoes previstas.';
        const declaracaoLines = doc.splitTextToSize(declaracao, maxWidth - 10);
        declaracaoLines.forEach((line: string) => {
          checkAndAddPage();
          doc.text(line, margin + 5, yPosition);
          yPosition += 4;
        });

        yPosition += 5;
        doc.setDrawColor(31, 206, 124);
        doc.setLineWidth(0.8);
        doc.rect(margin + 2, yPosition - 3, 4, 4);
        doc.setFillColor(31, 206, 124);
        doc.rect(margin + 2.5, yPosition - 2.5, 3, 3, 'F');
        doc.setFontSize(8);
        doc.setFont('helvetica', 'bold');
        doc.text('Confirmado', margin + 8, yPosition);
      }

      // ========== RODAPÉ EM TODAS AS PÁGINAS ==========
      const totalPages = doc.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);
        doc.setFontSize(8);
        doc.setTextColor(128, 128, 128);
        doc.setFont('helvetica', 'normal');
        doc.text(`Pagina ${i} de ${totalPages}`, pageWidth / 2, pageHeight - 10, { align: 'center' });
        doc.text('Plano de Contingencia Escolar', margin, pageHeight - 10);
        doc.text(dataGeracao, pageWidth - margin, pageHeight - 10, { align: 'right' });
      }

      // ========== SALVAR ==========
      const escolaNome = this.planoSelecionado.nmEscola?.replace(/[^a-zA-Z0-9]/g, '_') || 'Escola';
      const vigencia = this.planoSelecionado.vigencia || 'SemAno';
      const codigoPlano = this.planoSelecionado.cdPlano || '0';
      const nomeArquivo = `PC_${escolaNome}_${vigencia}_ID${codigoPlano}.pdf`;

      doc.save(nomeArquivo);
      this.toastr.success('PDF gerado e baixado com sucesso!');

    } catch (error: any) {
      console.error('Erro ao gerar PDF:', error);
      this.toastr.error(`Erro ao gerar o PDF: ${error.message || 'Erro desconhecido'}`);
    } finally {
      this.spinnerService.hide();
    }
  }

  private getStatusColorPDF(status: number): number[] {
    const statusColors: { [key: number]: number[] } = {
      0: [153, 153, 153],
      1: [40, 167, 69],
      2: [203, 37, 37],
      3: [0, 110, 189],
      4: [245, 126, 58],
      5: [245, 126, 58],
      6: [203, 37, 37],
    };
    return statusColors[status] || [153, 153, 153];
  }

  private getStatusTextoPDF(status: number): string {
    const statusMap: { [key: number]: string } = {
      0: 'Pendente',
      1: 'Aprovado',
      2: 'Devolvido para ajustes',
      3: 'Novo',
      4: 'Aguardando Validacao Supervisor de Ensino',
      5: 'Aguardando Validacao PEC CONVIVA',
      6: 'Devolvido para ajustes',
    };
    return statusMap[status] || 'Sem status';
  }

}
